import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';

import * as cloneDeep from 'clone-deep';
import { retry } from 'rxjs/operators';

export interface ApiError {
  code: number;
  message: string;
}

export interface ApiResponse<T> {
  headers: { [key: string]: string };
  body: T;
  error: ApiError;
}

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  public getApiUrl(): string {
    return <string>environment.apiUrl;

  }
  constructor(
    private _http: HttpClient,
  ) {

  }
  public async apiGet<T>(path: string, parameters: any = {}): Promise<ApiResponse<T>> {
    const result: ApiResponse<T> = {
      body: null,
      headers: {},
      error: null
    }

    for (let prop in parameters) {
      if (parameters[prop] === undefined || parameters[prop] === null) {
        delete parameters[prop];
      }
    }

    const response = <HttpResponse<T>>await this._http
      .get<T>(`${this.getApiUrl()}/api/${path}`, {
        params: parameters,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'none'
        }),
        observe: 'response',
        responseType: 'json'

      })
      .toPromise()
      .catch(error => {
        result.error = error;
      });

    if (!result.error) {
      result.body = <T>response.body;
      result.headers = response.headers.keys().reduce<{ [key: string]: string }>((headerResult, key) => {
        headerResult[key.toLowerCase()] = response.headers.get(key);
        return headerResult;
      }, {});
    }

    return result;
  }

  public async apiPostRefreshToken<T>(path: string, body: any, skip?: boolean): Promise<ApiResponse<T>> {
    const result: ApiResponse<T> = {
      body: null,
      headers: {},
      error: null
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'none',
      'Anonymous':'Anonymous'
      });
    //if (skipHttpInterceptor) {
    //  headers.append();
    //}
    try {
      const response = <HttpResponse<T>>(await this._http
        .post<T>(`${this.getApiUrl()}/api/${path}`, cloneDeep(body), {
          headers: headers,
          observe: 'response',
          responseType: 'json'
        })
        .toPromise()
        .catch(error => {
          result.error = error;
        }));

       if (!result.error) {
        result.body = response.body;
        result.headers = response.headers.keys().reduce<{ [key: string]: string }>((headerResult, key) => {
          headerResult[key.toLowerCase()] = response.headers.get(key);
          return headerResult;
        }, {});
      }
    }
    catch (e) {
      alert(e);
    }


    return result;
  }

  public async apiPost<T>(path: string, body: any, options:any = {}): Promise<ApiResponse<T>> {
    const result: ApiResponse<T> = {
      body: null,
      headers: {},
      error: null
    }

    const baseURL = options.baseURL || this.getApiUrl();

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'none'
    });
    //if (skipHttpInterceptor) {
    //  headers.append();
    //}
    try {
      const response = <HttpResponse<T>>(await this._http
        .post<T>(`${baseURL}/api/${path}`, cloneDeep(body), {
          headers: headers,
          observe: 'response',
          responseType: 'json'
        })
        .toPromise()
        .catch(error => {
          result.error = error;
        }));

      if (!result.error) {
        result.body = response.body;
        result.headers = response.headers.keys().reduce<{ [key: string]: string }>((headerResult, key) => {
          headerResult[key.toLowerCase()] = response.headers.get(key);
          return headerResult;
        }, {});
      }
    }
    catch (e) {
      alert(e);
    }


    return result;
  }


  public async apiPatch<T>(path: string, body: any): Promise<ApiResponse<T>> {
    const result: ApiResponse<T> = {
      body: null,
      headers: {},
      error: null
    }

    const response = <HttpResponse<T>>(await this._http
      .patch<T>(`${this.getApiUrl()}/api/${path}`, cloneDeep(body), {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'none'
        }),
        observe: 'response',
        responseType: 'json'
      })
      .toPromise()
      .catch(error => {
        result.error = error;
      }));

    if (!result.error) {
      result.body = response.body;
      result.headers = response.headers.keys().reduce<{ [key: string]: string }>((headerResult, key) => {
        headerResult[key] = response.headers.get(key);
        return headerResult;
      }, {});
    }

    return result;
  }

  public async apiDelete<T>(path: string, parameters: any = {}): Promise<ApiResponse<T>> {
    const result: ApiResponse<T> = {
      body: null,
      headers: {},
      error: null
    }

    const response = <HttpResponse<T>>await this._http
      .delete<T>(`${this.getApiUrl()}/api/${path}`, {
        params: parameters,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'none'
        }),
        observe: 'response',
        responseType: 'json'
      })
      .toPromise()
      .catch(error => {
        result.error = error;
      });

    if (!result.error) {
      result.body = <T>response.body;
      result.headers = response.headers.keys().reduce<{ [key: string]: string }>((headerResult, key) => {
        headerResult[key.toLowerCase()] = response.headers.get(key);
        return headerResult;
      }, {});
    }

    return result;
  }

  public async apiPut<T>(path: string, body: any): Promise<ApiResponse<T>> {

    const result: ApiResponse<T> = {
      body: null,
      headers: {},
      error: null
    }

    const response = <HttpResponse<T>>(await this._http
      .put<T>(`${this.getApiUrl()}/api/${path}`, cloneDeep(body), {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'none'
        }),
        observe: 'response',
        responseType: 'json'
      })
      .toPromise()
      .catch(error => {
        result.error = error;
      }));

    if (!result.error) {
      result.body = response.body;
      result.headers = response.headers.keys().reduce<{ [key: string]: string }>((headerResult, key) => {
        headerResult[key.toLowerCase()] = response.headers.get(key);
        return headerResult;
      }, {});
    }

    return result;
  }

}
